package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_01_18_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have just defeated hostile air elements who wanted to steal the shards of the Shield of Concar for their master — presumably either Samuel Thardos, Duke of Brij or Graz'zt. Falorn heals Goram and Bigglesworth. Bigglesworth, Caper, Dirk, and Falorn investigate a nearby abandoned shack. Some of the furniture is broken, but they find a log book which may have belonged to Even and Rachel, the lost couple from Well’s Bounty. Dirk reads the book; it seems to continue where the previous log book left off and ends at Newgrowth 51 with “Good finds in small valley. Storm picking up. Very windy.”")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday finds some shiny rocks and wants to remember to return to them later but is worried he’ll forget where they are. Caper reassures him that after a lifetime in the wilds, she will always be able to return to this location.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes return to Flower and continue North West starting at 1pm until about 7pm.")
    }
}
